import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FaSun, FaMoon } from 'react-icons/fa';

const Navigation = ({ theme, toggleTheme }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { to: 'projects', label: 'Proyectos' },
    { to: 'skills', label: 'Skills' },
    { to: 'about', label: 'Sobre mí' },
  ];

  const toggleBtnStyle = {
    width: '38px', height: '38px',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    borderRadius: '50%',
    border: '1px solid var(--border-subtle)',
    background: 'transparent',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
    transition: 'color 0.3s ease, background 0.3s ease, border-color 0.3s ease',
    marginRight: '8px',
  };

  return (
    <nav className={`navbar-custom ${scrolled ? 'scrolled' : ''}`} style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
      <div style={{ maxWidth: '1500px', margin: '0 auto', padding: '0 24px' }}>
        <div className="nav-pill">
          <Link
            to="home"
            smooth={true}
            duration={800}
            style={{ cursor: 'pointer', fontWeight: 800, fontSize: '1.15rem', color: 'var(--text-primary)', letterSpacing: '-0.02em', textDecoration: 'none' }}
          >
            AC<span style={{ color: 'var(--accent)', fontSize: '1.5rem', lineHeight: 0, marginLeft: '1px' }}>.</span>
          </Link>

          <div className="d-none d-lg-flex align-items-center gap-1">
            {navItems.map(item => (
              <Link
                key={item.to}
                to={item.to}
                spy={true}
                smooth={true}
                offset={-100}
                duration={800}
                activeClass="active"
                className="nav-link"
                style={{ cursor: 'pointer' }}
              >
                {item.label}
              </Link>
            ))}

            <button
              onClick={toggleTheme}
              style={toggleBtnStyle}
              aria-label="Cambiar tema"
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--accent)'; e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.background = 'var(--accent-soft)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-secondary)'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; e.currentTarget.style.background = 'transparent'; }}
            >
              {theme === 'dark' ? <FaSun size={14} /> : <FaMoon size={14} />}
            </button>

            <Link
              to="contact"
              smooth={true}
              duration={800}
              offset={-100}
              className="nav-cta-btn"
              style={{ cursor: 'pointer' }}
            >
              Contactar
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
